'use client';

import React, { useState } from 'react';
import { Search, Bell, Plus, Menu } from 'lucide-react';
import { LOGGED_IN_USER } from '@/lib/mockData';

interface TopbarProps {
  onMobileMenuToggle: () => void;
  pageTitle: string;
}

export default function Topbar({ onMobileMenuToggle, pageTitle }: TopbarProps) {
  const [searchFocused, setSearchFocused] = useState(false);

  return (
    <header className="h-16 bg-card border-b border-border flex items-center px-4 lg:px-6 gap-4 flex-shrink-0">
      {/* Mobile menu toggle */}
      <button
        onClick={onMobileMenuToggle}
        className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
      >
        <Menu size={20} className="text-muted-foreground" />
      </button>

      {/* Page title — mobile */}
      <h1 className="lg:hidden text-base font-semibold text-foreground">{pageTitle}</h1>

      {/* Search */}
      <div className={`hidden md:flex items-center gap-2 bg-muted rounded-lg px-3 py-2 transition-all duration-200 ${searchFocused ? 'ring-2 ring-primary/30 bg-card' : ''}`}
        style={{ minWidth: '260px' }}
      >
        <Search size={16} className="text-muted-foreground flex-shrink-0" />
        <input
          type="text"
          placeholder="Search tasks, projects..."
          className="bg-transparent text-sm text-foreground placeholder:text-muted-foreground outline-none w-full"
          onFocus={() => setSearchFocused(true)}
          onBlur={() => setSearchFocused(false)}
        />
        <kbd className="hidden lg:inline-flex items-center gap-1 text-xs text-muted-foreground bg-background px-1.5 py-0.5 rounded border border-border">
          ⌘K
        </kbd>
      </div>

      <div className="flex-1" />

      {/* Quick create */}
      <button className="hidden sm:flex btn-primary items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium">
        <Plus size={16} />
        <span>New Task</span>
      </button>

      {/* Notifications */}
      <button className="relative p-2 rounded-lg hover:bg-muted transition-colors">
        <Bell size={20} className="text-muted-foreground" />
        <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" />
      </button>

      {/* User avatar */}
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-semibold cursor-pointer hover:opacity-90 transition-opacity flex-shrink-0"
        style={{ backgroundColor: LOGGED_IN_USER.avatarColor }}
        title={LOGGED_IN_USER.name}
      >
        {LOGGED_IN_USER.avatarInitials}
      </div>
    </header>
  );
}